import { createVuetify } from 'vuetify'

import { browserAutofillDefaults } from '~/lib/browserAutofill.ts'

import { CPTheme } from '../utils'

import 'vuetify/styles'

export default createVuetify({
	defaults: {
		VTextField: browserAutofillDefaults(),
		VTextarea: browserAutofillDefaults(),
		VCombobox: browserAutofillDefaults(),
		VAutocomplete: browserAutofillDefaults()
	},
	theme: {
		defaultTheme: 'cpTheme',
		themes: {
			cpTheme: {
				dark: false,
				colors: CPTheme.colors as any
			}
		}
	}
})
